
import httpClient from "@/plugins/axios";


export const getChannels = async () => {
    const response = await httpClient.get(`/v1/chat/channels/?admin_view=1`);
    return response;
}


export const getChannel = async (id) => {
    const response = await httpClient.get(`/v1/chat/channels/${id}/?admin_view=1`);
    return response;
}

export const saveChannel = async (channel, newImageBlob, newImageName, removeImage) => {
    const formData = getFormData(channel, newImageBlob, newImageName, removeImage);

    if (channel.id) {
        return await updateChannel(channel.id, formData);
    }
    else {
        return await insertChannel(formData);
    }
}

const insertChannel = async (formData) => {
    const response = await httpClient.post('/v1/chat/channels/?admin_view=1', formData)
    return response;
}

const updateChannel = async (id, formData) => {
    const response = await httpClient.put(`/v1/chat/channels/${id}/?admin_view=1`, formData)
    return response;
}

const getFormData = (channel, newImageBlob, newImageName, removeImage) => {
    const formData = new FormData()

    if (channel.id) {
        formData.append('id', channel.id);
    }
    formData.append('is_active', channel.is_active);
    formData.append('channel_type', channel.channel_type);
    formData.append('translations', JSON.stringify(channel.translations));
    formData.append('group', channel.group);
    if (channel.send_notifications != null) {
        formData.append('send_notifications', channel.send_notifications);
    }

    formData.append('managers', JSON.stringify(channel.managers));

    if (newImageBlob) {
        formData.append('image', newImageBlob, newImageName);
    } else if (removeImage) {
        formData.append('remove_image', true)
    }


    return formData;
}